module.exports = __webpack_public_path__ + "img/homepage33.67637b99.png";